import { State } from '@shared/interfaces/state';
import { Observable } from 'rxjs';

export const STATE_REPOSITORY = 'StatusRepository';

export interface StatusRepository {
  url: string;

  getItems(): Observable<any>;

  add(state: State): Observable<any>;

  edit(state: State): Observable<any>;

  delete(item: any): Observable<any>;
}
